import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Returns "" (falsy) when there is no detail so that the common caller
// pattern `formatErr(e.response?.data?.detail) || e.message` correctly
// falls through to the underlying error message instead of showing the
// generic "Something went wrong" banner for every transient 502/504/etc.
export function formatErr(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  // Trial expiry payload: {"code":"trial_expired", "message":"..."}
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (typeof detail === "object") {
    try { return JSON.stringify(detail); } catch { return ""; }
  }
  return String(detail);
}

// Global handler — surface a single user-friendly toast for 402
// "trial_expired" so the UI never leaks the JSON shape, and so every
// blocked write/run shares the same message.
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 402 && detail && detail.code === "trial_expired") {
      try {
        if (!window.__pf_trial_toast_shown) {
          window.__pf_trial_toast_shown = true;
          alert(detail.message);
          setTimeout(() => { window.__pf_trial_toast_shown = false; }, 5000);
        }
      } catch (_) { /* no-op */ }
    }
    return Promise.reject(err);
  },
);

export default api;
